import { StyleSheet } from '@react-pdf/renderer';
import { grey } from '@mui/material/colors';
import { BlockNoteMarkStyles } from './block-note-pdf-inline';

export const FONT_SIZE = '8px';
export const LINE_HEIGHT = '12px';
export const FONT_FAMILY = 'MaisonNeue';

export const blockNotePdfStyles = StyleSheet.create({
  column: {
    display: 'flex',
    flexDirection: 'column',
  },
  base: {
    fontFamily: FONT_FAMILY,
    fontSize: FONT_SIZE,
    lineHeight: LINE_HEIGHT,
    fontWeight: 400,
    fontStyle: 'normal',
  },
  spacer: {
    height: LINE_HEIGHT,
  },
  listItemBase: {
    fontFamily: FONT_FAMILY,
    fontSize: FONT_SIZE,
    lineHeight: LINE_HEIGHT,
    fontWeight: 400,
    fontStyle: 'normal',
  },
  imageBlock: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
  },
  imageBlockRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  imageElement: {
    flexGrow: 0,
    flexShrink: 0,
    objectFit: 'contain',
  },
  imageElementConstrained: {
    maxWidth: '100%',
  },
  tableBlock: {
    margin: '7px 7px 12px 7px',
  },
  tableBlockIntrinsicAlign: {
    alignSelf: 'flex-start',
  },
  tableOuter: {
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
  },
  tableOuterWidthFull: {
    width: '100%',
  },
  tableRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: grey[300],
    borderBottomStyle: 'solid',
    borderLeftWidth: 1,
    borderLeftColor: grey[300],
    borderLeftStyle: 'solid',
    minHeight: 14,
  },
  tableRowFirst: {
    borderTopWidth: 1,
    borderTopColor: grey[300],
    borderTopStyle: 'solid',
  },
  tableCell: {
    flexGrow: 0,
    flexShrink: 0,
    minWidth: 0,
    borderRightWidth: 1,
    borderRightColor: grey[300],
    borderRightStyle: 'solid',
    paddingTop: 2,
    paddingBottom: 2,
    paddingLeft: 4,
    paddingRight: 4,
    justifyContent: 'flex-start',
  },
  tableCellLast: {
    borderRightWidth: 1,
    borderRightColor: grey[300],
    borderRightStyle: 'solid',
  },
  rowShell: {
    flexShrink: 0,
  },
});

export const marksToStyle = (marks: BlockNoteMarkStyles) => {
  const style: Record<string, string | number> = {
    fontFamily: FONT_FAMILY,
    fontSize: FONT_SIZE,
    lineHeight: LINE_HEIGHT,
    fontWeight: marks.bold ? 700 : 400,
    fontStyle: marks.italic ? 'italic' : 'normal',
  };
  if (marks.underline) style['textDecoration'] = 'underline';
  return style;
};
